module.exports = __webpack_public_path__ + "img/avatar2.9d1d3721.png";